import { createSlice } from '@reduxjs/toolkit';

export const isUsePoint = createSlice({
  name: 'isUsePoint',
  initialState: {
    data: false,
  },

  reducers: {
    setIsUsePoint: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setIsUsePoint } = isUsePoint.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getIsUsePoint = (state) => {
  return state.isUsePoint.data;
};

export default isUsePoint.reducer;
